module.exports = __webpack_public_path__ + "img/icons_illu_fahrrad.f40a302b.svg";